export const colors = {
  buttons: {
    primary: '#1AA22B',
    primaryHover: '#3CBF4C',
    secondary: '#084C6B',
    secondaryHover: '#064460',
    dark: '#032332',
    darkHover: '#032332',
    light: '#083A52',
    text: '#D6F2FF',
  },
  text: {
    dark: '#CCFFD3',
    accent: '#D6F2FF',
    light: '#D6F2FF',
    active: '#1AA22B',
  },
  background: {
    light: '#08415B',
    dark: '#002536',
    accent: '#052E41',
    medium: '#002A3D',
    transparent: '#052E41B2',
    tooltip: '#2E6077',
  },
  elements: {
    primary: '#0C4159',
    primaryHover: '#135472',
    dark: '#28779B',
    skeletonPrimary: '#033942',
    skeletonSecondary: '#08425C',
    accent: '#0C638A',
  },
  border: {
    primary: '#002536',
  },
  gradient: {
    fade: 'linear-gradient(90deg, #0B384D 40.38%, rgba(11, 56, 77, 0) 100%)',
  },
  accent: {
    success: '#387545',
    error: '#E5373A',
    soft: '#FFEBC3',
  },
  tags: {
    processing: '#88D5ED',
    success: '#BFE1A8',
    reject: '#FFA089',
    transfer: '#FFD889',
    mint: '#A8C8FF',
    text: '#3E3E3E',
  },
};
